<div [formGroup]="actionsForm">
  <div formArrayName="actions">
    <div [formGroupName]="index">
      <div class="form-row margim-bottom-0">
        <div class="col-2 action-title">
          {{ 'actions.account' | translate }}
        </div>
        <div class="col-2 action-title">
          {{ 'actions.action' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.action_date' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.followup_date' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.write_off_date' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.amount' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.agency' | translate }}
        </div>
        <div class="col-2 action-title">
          {{ 'actions.special_assignment' | translate }}
        </div>
        <div class="col-1 action-title">
          {{ 'actions.user_last_update' | translate }}
        </div>
      </div>
      <div class="form-row margim-top-0 margim-bottom-0 action-row">
        <div class="col-2">
          <input type="text" class="action-control" formControlName="account">
        </div>
        <div class="col-2">
          <input type="text" class="action-control" formControlName="action">
        </div>
        <div class="col-1">
          <input type="text" readonly="true" class="action-control" formControlName="actionDate">
        </div>
        <div class="col-1">
          <input type="text" class="action-control" formControlName="followUpDate">
        </div>
        <div class="col-1">
          <input type="text" class="action-control" formControlName="writeOffDate">
        </div>
        <div class="col-1">
          <input type="text" class="action-control" formControlName="amount">
        </div>
        <div class="col-1">
          <input type="text" class="action-control" formControlName="agency">
        </div>
        <div class="col-2">
          <input type="text" class="action-control" formControlName="specialAssignment">
        </div>
        <div class="col-1">
          <input type="text" class="action-control" formControlName="userLastUpdate">
        </div>
      </div>
      <div class="form-row margim-top-0">
        <div class="col-12 padding-0 action-remarks">
          <input type="text" class="action-control" formControlName="remarks">
        </div>
      </div>
    </div>
  </div>
</div>